
export const getExportDocument = (response: any): any => {
  let filename = "export.csv";
  const disposition = response.headers.get('content-disposition');

  if (disposition) {
    // RFC 6266 : filename* (UTF-8 percent-encodé) prime sur le filename ASCII de repli
    const utf8Matches = /filename\*=(?:UTF-8|utf-8)''([^;\n]*)/.exec(disposition);
    if (utf8Matches != null && utf8Matches[1]) {
      filename = decodeURIComponent(utf8Matches[1]);
    } else if (disposition.indexOf('filename') !== -1) {
      const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      const matches = filenameRegex.exec(disposition);
      if (matches != null && matches[1]) {
        filename = matches[1].replace(/['"]/g, '');
      }
    }
  }

  return response.blob().then((blob: Blob) => {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    const clickHandler = (): void => {
      setTimeout(() => {
        URL.revokeObjectURL(url);
        a.removeEventListener('click', clickHandler);
      }, 150);
    };
    a.addEventListener('click', clickHandler, false);
    a.click();
  })
}
